module.exports = __webpack_public_path__ + "static/media/cifrao.aede3aad.svg";